"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaybackFactory = void 0;
const index_1 = __importDefault(require("../dayjs/index"));
const LinkEntity_1 = require("../sub-clients/common/model/LinkEntity");
class PlaybackFactory {
}
exports.PlaybackFactory = PlaybackFactory;
PlaybackFactory.sample = (playback) => ({
    ...PlaybackFactory.defaultFields(),
    ...playback,
});
PlaybackFactory.defaultFields = () => ({
    type: 'STREAM',
    id: 'playback-id',
    duration: index_1.default.duration('PT18M39S'),
    maxResolutionAvailable: true,
    links: {
        createPlayerInteractedWithEvent: new LinkEntity_1.Link({ href: 'events' }),
        thumbnail: new LinkEntity_1.Link({ href: 'thumbnail' }),
    },
});
//# sourceMappingURL=PlaybackFactory.js.map